import React from "react";
import PageHero from "../../COMPONENTS/PAGE_HERO";
import PageNav from "../../COMPONENTS/PAGE_NAV";
import ContactBlock from "../../COMPONENTS/CONTACT_BLOCK";
import SponsorContactForm from "../../COMPONENTS/FORM/SPONSOR_CONTACT";
import Therapeutic from "../HOME_PAGE/SECTIONS/THERAPEUTIC";
import Industry from "./SECTIONS/INDUSTRY";
import Approach from "./SECTIONS/APPROACH";
import OurSolutions from "./SECTIONS/SOLUTIONS";
import Demographics from "./SECTIONS/DEMOGRAPHICS";
import { sponsorsHero } from "../../CONTENT/sponsors";
import useDocumentMeta from "../../UTILS/HOOKS/useDocumentMeta";

const links = [
  { id: "difference", label: "KUR difference" },
  { id: "approach", label: "How we deliver" },
  { id: "solutions", label: "Solutions" },
  { id: "therapeutic", label: "Therapeutic areas" },
  { id: "demographics", label: "Demographics" },
  { id: "contact", label: "Contact" },
];

const SponsorsPage = () => {
  useDocumentMeta({
    title: "For Sponsors | KUR Research",
    description:
      "Access diverse patient populations through KUR's Investigative Site Network: quick startup, rapid enrollment and quality data with one company, one solution.",
    path: "/sponsors",
  });

  return (
    <>
      <PageHero
        id="sponsors-hero-title"
        title={
          <>
            One company. <em>One solution.</em>
          </>
        }
        lead={sponsorsHero.lead}
        actions={sponsorsHero.actions}
        note={sponsorsHero.note}
        image={sponsorsHero.image}
        imageAlt={sponsorsHero.imageAlt}
        imagePosition="60% 30%"
      />
      <PageNav links={links} cta={{ label: "Contact sponsor team", href: "#contact" }} />
      <Industry />
      <Approach />
      <OurSolutions />
      <Therapeutic
        id="therapeutic"
        eyebrow="Our therapeutic arena"
        title="Phase II to IV trials across acute, chronic, vaccine and diagnostic research."
        showFullLink={false}
      />
      <Demographics />
      <ContactBlock
        showMap
        eyebrow="Contact sponsors"
        title="Discuss your next protocol with KUR."
        lead="KUR is interested in partnering with you for your clinical research needs. Please call or email to discuss how we can support your study as a trusted and experienced research partner."
        points={[
          "One department for CTA and budget across all KUR sites",
          "Realistic enrollment data from our patient database",
          "Site selection to first subject in as fast as 10 days",
        ]}
      >
        <SponsorContactForm />
      </ContactBlock>
    </>
  );
};

export default SponsorsPage;
